<template>
  <div class="container">
    <imgHeader imgUrl="/img/3公司动态-banner.jpg" />
    <NewsCom :title="$t('public.companyNews')" />
  </div>
</template>

<script>
  import NewsCom from '../../components/NewsCom.vue'
  export default {
    name: 'Dynamic',
    data() {
      return {}
    },
    components: { NewsCom },
  }
</script>

<style lang="scss" scoped></style>
